import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { Tracking, Master  } from '@providers/asset/index';
import { LocationPage } from '../location/page';
import { ItemPage } from '../item/page';

@Component({
  selector: 'page-tracking',
  templateUrl: 'page.html'
})
export class TrackingPage {

  data_awal:any={
    id           : '',
    tracking_name: '',
    status       : '0',
    date_time    : ''
  };

  data:any=this.data_awal;

  constructor(
    public navCtrl       : NavController,
    public trackingApi   : Tracking,
    public masterApi     : Master,
    public toastCtrl     : ToastController,
    public barcodeScanner:BarcodeScanner,
    public loadingCtrl   : LoadingController,
    public alertCtrl     : AlertController
  ) {

  }

  ionViewDidEnter() {
    this.get();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  confirmPost(){
    const confirm = this.alertCtrl.create({
      title: 'Anda yakin ?',
      message: 'Anda akan memulai sesi opname baru / menyelesaikan sesi opname yang sudah ada',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {

          }
        },
        {
          text: 'Ya',
          handler: () => {
            this.post();
          }
        }
      ]
    });
    confirm.present();
  }

  get(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = { status:0 };
    this.trackingApi.get(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.data = resp.data[0];
        this.trackingApi.active=1;
        this.trackingApi.data=resp.data[0];
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  post(){
    if(this.data.tracking_name==''){
      this.toastCtrl.create({
        message: 'Isi Activity Name Terlebih dahulu.',
        duration: 3000,
        position: 'top'
      }).present();
      return;
    }
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = this.data;
    if(params.status==0 && params.id!=''){
      params.status=1;
    }

    this.trackingApi.post(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        if(resp.data[0].status==0){
          this.get();
        }else{
          this.data = this.data_awal;
          this.data.tracking_name='';
          this.get();
        }

      this.presentToast(resp.msg);
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  scan(){
    this.barcodeScanner.scan().then(barcodeData => {
      if(barcodeData.text!=''){
        let loc = {location_code:barcodeData.text };
        this.masterApi.getLocation(loc).subscribe((resp:any) => {
          if(resp.data.length>0){
            let params = { tracking:1, location:resp.data[0] };
            this.navCtrl.push(ItemPage,params);
          }else{
            this.toastCtrl.create({
              message: 'location not found',
              duration: 3000,
              position: 'top'
            }).present();
          }
        }, (err) => {
          console.log(err);
        });;
        
      }
     }).catch(err => {
         console.log('Error', err);
     });
  }

  track(e){
    let params = { tracking:1 };
    this.navCtrl.push(LocationPage,params);
  }

  toListScannedItem(){
    let params = {tracking:1, item_tracking : 'scanned'};
    this.navCtrl.push(ItemPage, params);
  }

  toListNewItem(){
    let params = {tracking:1, item_tracking : 'new'};
    this.navCtrl.push(ItemPage, params);
  }

  toListModifiedItem(){
    let params = {tracking:1, item_tracking : 'modify'};
    this.navCtrl.push(ItemPage, params);
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/tracking/page.ts